import {
  useQueryStates,
  parseAsInteger,
  parseAsArrayOf,
  parseAsString,
  parseAsStringLiteral,
} from 'nuqs'
import {
  WorkerClassification,
  workerClassificationIds,
} from 'constants/workerClassification'

export const useFiltersQueryState = () => {
  const queryStates = useQueryStates(
    {
      userId: parseAsInteger,
      shiftId: parseAsInteger,
      companyId: parseAsInteger,
      status: parseAsArrayOf(parseAsString),
      workerClassification: parseAsArrayOf<WorkerClassification>(
        parseAsStringLiteral(workerClassificationIds)
      ),
      completedDaysAgo: parseAsInteger,
    },
    {
      urlKeys: {
        userId: 'user-id',
        shiftId: 'shift-id',
        companyId: 'company-id',
        status: 'status',
        workerClassification: 'worker-classification',
        completedDaysAgo: 'completed-days-ago',
      },
    }
  )

  return queryStates
}
